import "./styles.css";
import Container from "../../../components/Container";
import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Input, Space } from "antd";
import { db } from "../../../services/firebase";
import { collection, getDocs } from "firebase/firestore";
import { buscarAtividades } from "../../../services/atividadeService";
import {
  EyeOutlined,
  SearchOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
  SettingOutlined,
  HistoryOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

function CertificateList() {
  const [certificados, setCertificados] = useState([]);
  const [certificadosFilter, setCertificadosFilter] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usuario, setUsuario] = useState({});

  // Estatísticas
  const [stats, setStats] = useState({
    totalClientes: 0,
    totalValvulas: 0,
    totalCertificados: 0,
  });

  // Atividades recentes do sistema
  const [atividades, setAtividades] = useState([]);

  const fetchAtividades = useCallback(async () => {
    const data = await buscarAtividades(10);
    setAtividades(data);
  }, []);

  const formatarDataHora = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp.seconds * 1000);
    const dia = date.toLocaleDateString("pt-BR");
    const hora = date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
    return `${dia} às ${hora}`;
  };

  useEffect(() => {
    const usuarioData = JSON.parse(sessionStorage.getItem("seepilUsuario"));
    setUsuario(usuarioData || {});
    fetchAtividades();
  }, [fetchAtividades]);

  const handleSearch = useCallback(
    (search, key) => {
      const searchTerm = search.toLowerCase();
      const data = certificados.filter((item) => {
        const value = item[key];
        return value?.toString().toLowerCase().includes(searchTerm);
      });
      setCertificadosFilter(search ? data : certificados);
    },
    [certificados]
  );

  const reset = useCallback(() => {
    setCertificadosFilter(certificados);
  }, [certificados]);

  const columns = [
    {
      title: "TAG",
      dataIndex: "tag",
      key: "tag",
      filterDropdown: ({ setSelectedKeys, selectedKeys, close }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Filtrar por Tag"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            style={{ marginBottom: 8, width: 250 }}
          />
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(selectedKeys[0], "tag");
                close();
              }}
              icon={<SearchOutlined />}
              size="small"
            >
              Filtrar
            </Button>
            <Button
              onClick={() => {
                setSelectedKeys([]);
                reset();
                close();
              }}
              size="small"
            >
              Limpar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "#e6be01" : undefined, fontSize: 16 }}
        />
      ),
    },
    {
      title: "Nº Série",
      dataIndex: "numeroSerie",
      key: "numeroSerie",
      filterDropdown: ({ setSelectedKeys, selectedKeys, close }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Filtrar por Nº Série"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            style={{ marginBottom: 8, width: 250 }}
          />
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(selectedKeys[0], "numeroSerie");
                close();
              }}
              icon={<SearchOutlined />}
              size="small"
            >
              Filtrar
            </Button>
            <Button
              onClick={() => {
                setSelectedKeys([]);
                reset();
                close();
              }}
              size="small"
            >
              Limpar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "#e6be01" : undefined, fontSize: 16 }}
        />
      ),
    },
    {
      title: "Cliente",
      dataIndex: "nomeEmpresa",
      key: "nomeEmpresa",
      filterDropdown: ({ setSelectedKeys, selectedKeys, close }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Filtrar por Empresa"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            style={{ marginBottom: 8, width: 250 }}
          />
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(selectedKeys[0], "nomeEmpresa");
                close();
              }}
              icon={<SearchOutlined />}
              size="small"
            >
              Filtrar
            </Button>
            <Button
              onClick={() => {
                setSelectedKeys([]);
                reset();
                close();
              }}
              size="small"
            >
              Limpar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "#e6be01" : undefined, fontSize: 16 }}
        />
      ),
    },
    {
      title: "Unidade",
      dataIndex: "unidadeCliente",
      key: "unidadeCliente",
    },
    {
      title: "Tipo de Válvula",
      dataIndex: "tipoValvula",
      key: "tipoValvula",
    },
    {
      title: "Tipo de Certificado",
      dataIndex: "tipoCertificado",
      key: "tipoCertificado",
    },
    {
      title: "Nº Certificado",
      dataIndex: "numeroCertificado",
      key: "numeroCertificado",
    },
    {
      title: "SPL",
      dataIndex: "spl",
      key: "spl",
    },
    {
      title: "Certificado",
      dataIndex: "id",
      key: "id",
      render: (value) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link
            to={`/admin/cadastro-certificados/${value}`}
            className="view-btn"
          >
            <EyeOutlined />
          </Link>
        </div>
      ),
    },
  ];

  const fetchClientsFirebase = useCallback(async () => {
    const snapshot = await getDocs(collection(db, "clientes"));
    const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    return data;
  }, []);

  const fetchValvesFirebase = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "certificados"));
      const certificadosList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const clients = await fetchClientsFirebase();
      const data = certificadosList.map((cert) => {
        const client = clients.find((c) => c.id === cert.cliente_id);
        return {
          ...client,
          ...cert,
        };
      });
      setCertificados(data);
      setCertificadosFilter(data);

      // Buscar contagem real de válvulas das 3 collections
      const [psvSnapshot, controleSnapshot, bloqueioSnapshot] = await Promise.all([
        getDocs(collection(db, "valvulasPSV")),
        getDocs(collection(db, "valvulasControle")),
        getDocs(collection(db, "valvulasBloqueio")),
      ]);

      const totalValvulas = psvSnapshot.size + controleSnapshot.size + bloqueioSnapshot.size;

      // Atualizar estatísticas
      setStats({
        totalClientes: clients.length,
        totalValvulas: totalValvulas,
        totalCertificados: certificadosList.length,
      });

      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      setLoading(false);
    }
  }, [fetchClientsFirebase]);

  useEffect(() => {
    fetchValvesFirebase();
  }, [fetchValvesFirebase]);

  return (
    <Container>
      <div className="dashboard-container">
        {/* Card de Boas-vindas */}
        <div className="welcome-card">
          <div className="welcome-content">
            <h1 className="welcome-title">Bem-vindo ao Seepil Valve Care</h1>
            <p className="welcome-subtitle">
              <span className="welcome-name">
                {usuario.nomeUsuario || "Administrador"}
              </span>
              <span className="welcome-divider">•</span>
              <span className="welcome-company">
                {usuario.nomeEmpresa || "Seepil"}
              </span>
            </p>
          </div>
          <div className="welcome-decoration">
            <div className="decor-circle-1"></div>
            <div className="decor-circle-2"></div>
          </div>
        </div>

        {/* Cards de Estatísticas */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">
              <TeamOutlined />
            </div>
            <div className="stat-info">
              <span className="stat-value">{stats.totalClientes}</span>
              <span className="stat-label">Total Clientes</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <SettingOutlined />
            </div>
            <div className="stat-info">
              <span className="stat-value">{stats.totalValvulas}</span>
              <span className="stat-label">Válvulas Cadastradas</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <SafetyCertificateOutlined />
            </div>
            <div className="stat-info">
              <span className="stat-value">{stats.totalCertificados}</span>
              <span className="stat-label">Certificados Ativos</span>
            </div>
          </div>
        </div>

        {/* Tabela de Certificados */}
        <div className="table-card">
          <div className="card-header">
            <div className="card-header-left">
              <div className="card-icon">
                <SafetyCertificateOutlined />
              </div>
              <div>
                <h2 className="card-title">Certificados Recentes</h2>
                <p className="card-subtitle">
                  Você poderá acessar através da tabela abaixo ou utilizando o
                  menu lateral.
                </p>
              </div>
            </div>
            <Link to="/admin/certificados" className="view-all-btn">
              Ver todos
            </Link>
          </div>

          <Table
            dataSource={certificadosFilter}
            columns={columns}
            bordered
            loading={loading}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            scroll={{ x: 1000 }}
            className="custom-table"
          />
        </div>

        {/* Card de Atividades Recentes */}
        <div className="activity-card">
          <div className="card-header">
            <div className="card-header-left">
              <div className="card-icon">
                <HistoryOutlined />
              </div>
              <h2 className="card-title">Últimas Atividades</h2>
            </div>
            <button className="view-all-btn">Ver todas</button>
          </div>

          <div className="activity-list">
            {atividades.length === 0 ? (
              <p style={{ textAlign: "center", color: "#999", padding: "20px" }}>
                Nenhuma atividade registrada ainda.
              </p>
            ) : (
              atividades.map((atividade, index) => (
                <div
                  key={atividade.id}
                  className={`activity-item ${
                    index === atividades.length - 1 ? "last" : ""
                  }`}
                >
                  <div className="activity-dot"></div>
                  <div className="activity-content">
                    <div className="activity-main">
                      <span className="activity-action">{atividade.acao}</span>
                      <span className="activity-target">{atividade.alvo}</span>
                    </div>
                    <div className="activity-meta">
                      <span className="activity-user">{atividade.usuario}</span>
                      <span className="activity-datetime">
                        <ClockCircleOutlined style={{ marginRight: 4 }} />
                        {formatarDataHora(atividade.dataHora)}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}

export default CertificateList;
